/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import { isMessage, getImageAtSize } from '../../lib/utils';

const propTypes = {
    page: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
        titleSuffix: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.shape({}),
        imageSize: PropTypes.string,
        keywords: PropTypes.arrayOf(PropTypes.string),
    }),
    siteTitle: PropTypes.string,
    withoutTitleSuffix: PropTypes.bool,
    onChange: PropTypes.func,
};

function PageMeta({
    page = null,
    siteTitle = 'Projections Tënk',
    withoutTitleSuffix = false,
    onChange = null,
}) {
    const intl = useIntl();

    const {
        url = null,
        title = null,
        handle = null,
        metaTitle: pageMetaTitle = null,
        description = null,
        image = null,
        imageSize = 'share',
        keywords = null,
    } = page || {};

    const baseTitle = pageMetaTitle || title;
    const metaTitle =
        title !== null && !withoutTitleSuffix && pageMetaTitle === null
            ? `${title} | ${siteTitle}`
            : baseTitle;
    const finalTitle = handle === 'home' ? siteTitle : metaTitle;

    const imageAtSize = getImageAtSize(image, imageSize);

    const metaDescription =
        (isMessage(description) ? intl.formatMessage(description) : description) || null;

    const metaKeywords = keywords !== null ? keywords.join(',') : null;
    let metaUrl = null;
    if (url !== null) {
        metaUrl = url.match(/^(https?)?:\/\//i)
            ? url
            : `${window.location.protocol}//${window.location.host}${url}`;
    }

    return (
        <Helmet onChangeClientState={onChange}>
            {finalTitle !== null ? <title>{finalTitle}</title> : null}
            {metaDescription !== null ? (
                <meta name="description" content={metaDescription} />
            ) : null}
            {metaKeywords !== null ? <meta name="keywords" content={metaKeywords} /> : null}

            <link rel="canonical" href={metaUrl} />

            {/* Open graph */}
            {imageAtSize !== null ? <meta property="og:image" content={imageAtSize.url} /> : null}
            {imageAtSize !== null ? (
                <meta property="og:image:url" content={imageAtSize.url} />
            ) : null}
            {imageAtSize !== null ? (
                <meta property="og:image:width" content={imageAtSize.width} />
            ) : null}
            {imageAtSize !== null ? (
                <meta property="og:image:height" content={imageAtSize.height} />
            ) : null}
            <meta property="og:title" content={title} />
            {metaDescription !== null ? (
                <meta property="og:description" content={metaDescription} />
            ) : null}
            {metaUrl !== null ? <meta property="og:url" content={metaUrl} /> : null}

            {/* Twitter */}
            <meta
                name="twitter:card"
                content={imageAtSize !== null ? 'summary_large_image' : 'summary'}
            />
            <meta name="twitter:title" content={title} />
            {metaDescription !== null ? (
                <meta name="twitter:description" content={metaDescription} />
            ) : null}
            {imageAtSize !== null ? <meta name="twitter:image" content={imageAtSize.url} /> : null}
        </Helmet>
    );
}

PageMeta.propTypes = propTypes;

export default PageMeta;
